const INTERCOM_IFRAME_ELEMENT_SELECTOR = '#intercom-container .intercom-app .intercom-messenger-frame iframe[name="intercom-messenger-frame"]';
const INTERCOM_ARTICLES_SELECTOR = '[class*="intercom-home-screen-messenger-card-"]:not(.intercom-home-screen-search-browse-card)';
const INTERCOM_CONTAINER_APP_SELECTOR = '#intercom-container .intercom-app';

export default {
    data: () => ({
        observer: null,
    }),

    methods: {
        mutationObserverCallback(mutationRecords) {
            const intercomContainerApp = document.querySelector(INTERCOM_CONTAINER_APP_SELECTOR);
            const intercomContainerFrame = document.querySelector(`${INTERCOM_CONTAINER_APP_SELECTOR} .intercom-messenger-frame`);

            mutationRecords.forEach((mutation) => {
                const firstAddedNode = mutation.addedNodes[0];

                if (firstAddedNode === intercomContainerApp || firstAddedNode === intercomContainerFrame) {
                    this.hideIntercomArticles();
                }
            });
        },

        createObserverInstance() {
            const body = document.querySelector('body');

            const observer = new MutationObserver(this.mutationObserverCallback);

            observer.observe(body, {
                subtree: true,
                childList: true,
            });

            this.observer = observer;
        },

        hideIntercomArticles() {
            const intercomIframeElement = document.querySelector(INTERCOM_IFRAME_ELEMENT_SELECTOR);

            const iframeWindow = intercomIframeElement.contentWindow.document;

            const iframeCss = `${INTERCOM_ARTICLES_SELECTOR} { display: none; }`;
            const iframeHead = iframeWindow.head;
            const iframeStyle = iframeWindow.createElement('style');

            iframeHead.appendChild(iframeStyle);

            iframeStyle.type = 'text/css';

            iframeStyle.appendChild(document.createTextNode(iframeCss));
        },

        disconnectObserver() {
            if (this.observer) {
                this.observer.disconnect();
            }
        },
    },
};
